import '@css/app.scss';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import axios from 'axios';
import { appLog } from './functions';
import NMIPaymentForm from './NMIPaymentForm.vue';
import ValorPaymentForm from './ValorPaymentForm.vue';

async function init(appRootElement) {
  /* Get initial settings from backend */
  const merchantType = window['_APP_CONFIG']?.merchant?.settings?.type;
  let App = null;
  switch (merchantType) {
    case 'valor':
      App = ValorPaymentForm;
      // App = (await import('./ValorPaymentForm.vue')).default;
      appLog('Valor Pay: %s', (window['_APP_CONFIG']?.merchant?.settings?.is_staging ? 'Sandbox' : 'Production') );
      break;
    case 'nmi':
    default:
      App = NMIPaymentForm;
      // App = (await import('./NMIPaymentForm.vue')).default;
      appLog('NMI')
      break;
  }

  /* General logic for app */
  const app = createApp(App);     // create app instance
  const storage = createPinia();  // create pinia instance
  app.use(storage);

  /* Backend: Add initial data */
  app.provide('appConfig', window['_APP_CONFIG']);

  /* Pre-creating JS http client */
  const apiClient = axios.create({
    baseURL: window['_APP_CONFIG']?.restUrl,
    headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': window['_APP_CONFIG']?.restNonce }
  })
  app.provide('apiClient', apiClient);
  if (appRootElement instanceof HTMLElement) {
    app.mount( appRootElement );
  } else {
    appLog('wrong root')
  }
}


document.addEventListener('DOMContentLoaded', e => {
  const rootElementId = 'app-root';
  const appRootElement = document.getElementById(rootElementId);
  if (appRootElement instanceof HTMLElement) {
    init(appRootElement);
  } else {
    console.error('%c#%s%c: root container is not found', 'font-weight: 600', rootElementId, 'font-weight: 400')
  }
});
